import { createModel } from 'ContentData/reducers/helpers/asyncResourceModel';
import { fromJS } from 'immutable';
import { PRIMITIVE_JS_VALUE, JS_OBJECT, IMMUTABLE_MAP, IMMUTABLE_LIST, ALLOWLISTED_SCHEMA_OBJECT, NestedImmutableMap, IMMUTABLE_SET, IMMUTABLE_MAP_OF_LAYOUT_TREES, IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES
// @ts-expect-error module not migrated yet
} from 'ContentEditorUI/redux/inpageSync/types';
import emailBasicSyncConfig from './emailBasicSyncConfig';
export default (() => Object.assign({}, emailBasicSyncConfig, {
  abTest: JS_OBJECT,
  blogs: JS_OBJECT,
  configModel: JS_OBJECT,
  configValues: JS_OBJECT,
  contentModel: JS_OBJECT,
  contentSchema: ALLOWLISTED_SCHEMA_OBJECT,
  critsit: JS_OBJECT,
  ctas: JS_OBJECT,
  defaultSettings: JS_OBJECT,
  defaultStyleSettings: JS_OBJECT,
  modules: {
    immutable: true,
    allowlist: ['present', 'redoCount', 'undoCount'],
    nestedConfig: {
      redoCount: PRIMITIVE_JS_VALUE,
      undoCount: PRIMITIVE_JS_VALUE,
      present: NestedImmutableMap({
        uneditableWidgets: IMMUTABLE_MAP,
        schemaLayoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        layoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        flexAreaTree: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        gridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutWidgets: IMMUTABLE_MAP,
        layoutSectionWidgets: IMMUTABLE_MAP,
        schemaWidgetContainers: IMMUTABLE_MAP,
        widgetContainers: IMMUTABLE_MAP,
        schemaWidgets: IMMUTABLE_MAP,
        fakeModules: IMMUTABLE_MAP,
        widgets: IMMUTABLE_MAP,
        contentCss: IMMUTABLE_MAP,
        moduleMetaData: IMMUTABLE_MAP,
        widgetsInRichText: IMMUTABLE_MAP,
        clonedModulesPendingDomOperations: IMMUTABLE_SET,
        themePageOverrides: JS_OBJECT,
        // email only
        flexAreaSections: IMMUTABLE_LIST,
        flexAreaStyles: IMMUTABLE_MAP,
        flexAreaStyleSettings: IMMUTABLE_MAP,
        userModuleDefaults: IMMUTABLE_MAP,
        sidebarTree: IMMUTABLE_MAP
      })
    }
  },
  savedSections: JS_OBJECT,
  pageSettings: JS_OBJECT,
  routing: JS_OBJECT,
  rssFeedUrlValidation: {
    immutable: false,
    exportBeforeMessageSent: valueToExport => {
      return valueToExport.get('_internalState').toJS();
    },
    parseAfterMessageReceived: valueToImport => {
      return createModel(fromJS(valueToImport));
    },
    customCompareFunction(prevValue, nextValue) {
      const prevValueExported = this.exportBeforeMessageSent(prevValue);
      const nextValueExported = this.exportBeforeMessageSent(nextValue);
      // In this case the data changes only when it's loaded again from the backend,
      // so sending it down only when the loading state change.
      return prevValueExported.loading === nextValueExported.loading;
    }
  },
  socialNetworks: JS_OBJECT,
  paymentsEligibility: JS_OBJECT
}));